import { CalendarDays, Clock3, FileText, MapPin } from "lucide-react";
import { useLandingContent } from "@/lib/landing/LandingContentProvider";
const icons = [CalendarDays, FileText, MapPin, Clock3];
export default function LandingTrustStrip() {
  const { content } = useLandingContent();
  return (
    <section
      aria-label="Why book with Smartly"
      className="landing-band-dark border-y border-landing-border py-[30px]"
    >
      <div className="landing-container grid grid-cols-2 gap-6 lg:grid-cols-4">
        {content.trust.map(({ title, text }, i) => {
          const Icon = icons[i];
          return (
            <div key={i} className="flex gap-3">
              <Icon className="mt-0.5 h-[22px] w-[22px] shrink-0 text-landing-red-soft" />
              <div>
                <p className="text-sm font-semibold text-landing-on-dark sm:text-[15.5px]">
                  {title}
                </p>
                <p className="mt-1 text-[13px] leading-relaxed sm:text-sm text-landing-on-dark-muted">
                  {text}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
